import React from 'react';
import { Star, Quote } from 'lucide-react';
const TESTIMONIALS = [{
  name: 'María',
  role: 'Mamá de 2 niños',
  quote: 'Dejamos de pelear todos los días. Ahora hay más calma en casa.',
  location: 'Buenos Aires'
}, {
  name: 'Lucas',
  role: 'Papá de 3',
  quote: 'Por primera vez siento que sé qué hacer con el celular.',
  location: 'Córdoba'
}, {
  name: 'Ana',
  role: 'Mamá',
  quote: 'No es teoría. Es práctico y real.',
  location: 'Rosario'
}, {
  name: 'Carolina',
  role: 'Mamá de mellizos',
  quote: 'Mis hijos volvieron a jugar juntos sin pantallas. No lo podía creer.',
  location: 'Mendoza'
}, {
  name: 'Martín',
  role: 'Papá primerizo',
  quote: 'Ojalá hubiera encontrado esto antes. Cambió nuestra rutina familiar.',
  location: 'La Plata'
}];
export function Testimonials() {
  return <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto px-4" data-id="element-218">
      {TESTIMONIALS.map((t, i) => <div key={i} className="bg-white p-6 rounded-xl shadow-lg border border-gray-100 flex flex-col relative" data-id="element-219">
          <Quote className="absolute top-4 right-4 text-blue-100 w-10 h-10" data-id="element-220" />
          <div className="flex gap-1 mb-4" data-id="element-221">
            {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-5 h-5 text-yellow-400 fill-yellow-400" data-id="element-222" />)}
          </div>
          <p className="text-gray-700 italic mb-6 flex-grow text-lg" data-id="element-223">
            "{t.quote}"
          </p>
          <div className="mt-auto border-t pt-4 border-gray-100" data-id="element-224">
            <p className="font-bold text-gray-900" data-id="element-225">{t.name}</p>
            <p className="text-sm text-gray-500" data-id="element-226">
              {t.role} - {t.location}
            </p>
          </div>
        </div>)}
    </div>;
}